import React from "react";
import {Dropdown} from "react-bootstrap";
import {connect} from "react-redux";
import {logout} from "../UserIdentification/action.js";

const UserButton = ({logout, gravatarImage, name}) => {
    return(
        <div className="main_user">
            <Dropdown>
              <Dropdown.Toggle variant="dark" id="dropdown-basic" className="bg-transparent">
                <img src={gravatarImage ? "/root/Images/"+gravatarImage:"/root/Images/Default.svg"} className="userIcon" alt="Avatar" />
              </Dropdown.Toggle>
            
              <Dropdown.Menu>
                <Dropdown.Item href="/main" className="text-center">Welcome  {name}</Dropdown.Item>
                <Dropdown.Item href="/main/editProfile" className="text-center">Edit Profile</Dropdown.Item>
                <Dropdown.Item href="/changePassword" className="text-center">Change Password</Dropdown.Item>
                <Dropdown.Item className="text-center" onClick={() => logout()}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

function mapStateToProps (state) {
    return {gravatarImage: state.user.gravatarImage, name: state.user.name}
}

export default connect(mapStateToProps, {logout})(UserButton);